import type { Review } from '../types/review';

// ─────────────────────────────────────────────────────────────
// CUSTOMER REVIEWS
// `reviewsAggregate` — owner-supplied lifetime rating and review count from
// customer reviews collected since 2020 (keep the source records on file).
// `reviews` — individual customer reviews. Paste exported reviews here
// (Shopify / Judge.me / Amazon / Etsy CSV) or sync from the review app.
// ─────────────────────────────────────────────────────────────

export const reviewsConfig = {
  pageSize: 6,
  purchaseOptions: ['Individual lights', '4-Light System', '8-Light System', '12-Light System', '24-Light System'],
};

export type ReviewsAggregate = {
  average: number;
  /** Total reviews on record. Displayed as "2,300+". */
  count: number;
  sinceYear: number;
};

export const reviewsAggregate: ReviewsAggregate | null = {
  average: 4.9,
  count: 2300,
  sinceYear: 2020,
};

export const reviews: Review[] = [];
